import React, { Component } from 'react'
import Plyr from 'plyr'

const iframeContainerStyle = {
  position: 'relative',
  overflow: 'hidden',
  paddingTop: '56.25%'
}

const iframeStyle = {
  position: 'absolute',
  top: '0',
  left: '0',
  width: '100%',
  height: '100%'
}

const placeholderStyle = {
  position: 'absolute',
  top: '0',
  left: '0',
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#000',
  color: '#fff',
  cursor: 'pointer',
  textAlign: 'center',
  padding: '20px'
}

const playButtonStyle = {
  width: '68px',
  height: '48px',
  marginBottom: '20px'
}

const messageStyle = {
  fontSize: '16px',
  marginBottom: '10px',
  fontWeight: '500',
}

const subMessageStyle = {
  fontSize: '14px',
}

const messageContainerStyle = {
  backgroundColor: 'black',
  padding: '10px',
  borderRadius: '5px',
}


// This component is a little tricky because the plyr embeds do not work
// with greenhouse (all the iframes, etc). So we have to use the iframe
// embeds for youtube and vimeo. We want to keep the plyr events on the
// customer sites so we have to use plyr. It works on customer sites tho.

export default class ThirdPartyEmbeddedPlyr extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isInGreenhouse: false
    }
  }

  componentDidMount() {
    // Check if we're in the Greenhouse editor
    const isInGreenhouse = window.parent !== window &&
      (window.location.hostname.includes('greenhousepreview') ||
        window.parent.location?.href?.includes('/greenhouse/') ||
        window.parent.App?.iframeLoaded === true)
    this.setState({ isInGreenhouse })
  }

  handlePlaceholderClick = () => {
    const { provider, embedId } = this.props
    let url = ''

    if (provider === 'youtube') {
      url = `https://www.youtube.com/watch?v=${embedId}`
    } else if (provider === 'vimeo') {
      url = `https://vimeo.com/${embedId}`
    }

    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer')
    }
  }

  renderPlaceholder() {
    const { provider } = this.props
    const providerName = provider === 'youtube' ? 'YouTube' : 'Vimeo'

    console.log('Rendering placeholder for', this.props, 'video')

    return (
      <div style={iframeContainerStyle}>
        <div
          onClick={this.handlePlaceholderClick}
          className="retain-default-behavior video-placeholder"
          // background image is the thumbnail
          // for the video, if available
          style={{
            ...placeholderStyle,
            backgroundImage: this.props.media.thumbnails.original ? `url(${this.props.media.thumbnails.original})` : 'none',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <svg
            style={playButtonStyle}
            viewBox="0 0 68 48"
            onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
            onMouseLeave={(e) => e.currentTarget.style.opacity = '0.8'}
          >
            <path
              fill={provider === 'youtube' ? '#f00' : '#00adef'}
              d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"
            />
            <path fill="#fff" d="M 45,24 27,14 27,34" />
          </svg>
          <div style={messageContainerStyle}>
            <div style={messageStyle}>
              Can't play {providerName} videos in Greenhouse editor
            </div>
            <div style={subMessageStyle}>
              Click to open in {providerName}
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { isInGreenhouse } = this.state

    if (isInGreenhouse && this.props.provider === 'youtube') {
      return this.renderPlaceholder()
    }

    if (this.props.provider === 'youtube') {
      return (
        <div style={iframeContainerStyle}>
          <iframe
            style={iframeStyle}
            src={`https://www.youtube.com/embed/${this.props.embedId}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen={false}
          />
        </div>
      )
    } else if (this.props.provider === 'vimeo') {
      return (
        <div style={iframeContainerStyle}>
          <iframe
            style={iframeStyle}
            src={`https://player.vimeo.com/video/${this.props.embedId}`}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen={false}
          />
        </div>
      )
    } else {
      return null
    }
  }
}
